import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AuthoritiesEnum, CRUDActionEnum } from "~/types/enums";
import { Box, Button, Card, Icon, InputText, Text } from "~/components-shared";
import apiTokensActionCreators from "~/store/apiTokens/actions";
import moment from "moment";
import { ApiTokenActionEnum } from "~/store/apiTokens/types";
import useAbacExt from "~/hooks/abac";
import toastsActionCreators from "~/store/toasts/actions";
import styled from "styled-components";
const Info = styled(Text)`
  position: absolute;
  top: 0;
  right: 0;
`;
const ProfilePersonalTokenCard = _ref => {
  let {
    token,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const [showToken, setShowToken] = React.useState(false);
  const handleRevoke = () => {
    dispatch(apiTokensActionCreators.actionChanged(ApiTokenActionEnum.REVOKE, token.id));
  };
  const handleDelete = () => {
    dispatch(apiTokensActionCreators.actionChanged(CRUDActionEnum.DELETE, token.id));
  };
  const handleCopy = () => {
    const type = "text/plain";
    const blob = new Blob([token.token], {
      type
    });
    const data = [new ClipboardItem({
      [type]: blob
    })];
    navigator.clipboard.write(data).then(() => {
      dispatch(toastsActionCreators.pushed({
        message: t("ProfilePersonalTokenCard.copiedToClipboard", {
          name: token.name
        }),
        timeout: 3000
      }));
    });
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(InputText, {
    value: token.token,
    label: token.name,
    autoComplete: "off",
    fullWidth: true,
    type: showToken ? "text" : "password",
    outline: false,
    disabled: true,
    elemBefore: /*#__PURE__*/React.createElement(Icon, {
      src: "encrypted",
      color: "textSecondary",
      s: {
        mr: 2
      }
    }),
    elemAfter: /*#__PURE__*/React.createElement(Box, {
      gap: 1,
      s: {
        ml: 2,
        mr: -2
      }
    }, /*#__PURE__*/React.createElement(Button, {
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": showToken ? t("common.actions.hide") : t("common.actions.show"),
      onClick: () => setShowToken(prev => !prev),
      s: {
        p: 1
      },
      color: "transparent"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: showToken ? "visibility" : "visibilityOff",
      s: {
        mt: -0.5
      }
    })), /*#__PURE__*/React.createElement(Button, {
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.copy"),
      onClick: handleCopy,
      fontSize: 3,
      s: {
        p: 1
      },
      color: "transparent"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "copy",
      s: {
        mt: -0.5
      }
    })), userHas(AuthoritiesEnum.PROFILE_WRITE) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      fontSize: 3,
      s: {
        p: 1
      },
      onClick: handleRevoke,
      disabled: !!token.revokedAt,
      color: token.revokedAt ? "dangerTransparent" : "transparent",
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": token.revokedAt ? t("ProfilePersonalTokenCard.revoked") : t("common.actions.revoke")
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "undo",
      s: {
        mt: -0.5
      }
    })), /*#__PURE__*/React.createElement(Button, {
      "data-tooltip-id": "general-tooltip",
      "data-tooltip-content": t("common.actions.delete"),
      fontSize: 3,
      s: {
        p: 1
      },
      onClick: handleDelete,
      color: "transparent"
    }, /*#__PURE__*/React.createElement(Icon, {
      src: "bin",
      s: {
        mt: -0.5
      }
    }))))
  }), /*#__PURE__*/React.createElement(Info, {
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      textDecoration: "underline",
      cursor: "help"
    },
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-html": `<strong>Scopes assigned:</strong><br/>${token.scopes.join("<br/>")}`
  }, "selected scopes"), " • ", moment(token.expiresAt).valueOf() < moment().valueOf() ? /*#__PURE__*/React.createElement(Text, {
    color: "danger"
  }, "expired ", moment(token.expiresAt).local().startOf("seconds").fromNow(false)) : /*#__PURE__*/React.createElement(Text, null, "expires in ", moment(token.expiresAt).local().startOf("seconds").fromNow(true))));
};
export default ProfilePersonalTokenCard;